import { render, staticRenderFns } from "./PatentFileForm.vue?vue&type=template&id=27bdc451&scoped=true&"
import script from "./PatentFileForm.vue?vue&type=script&lang=ts&"
export * from "./PatentFileForm.vue?vue&type=script&lang=ts&"
import style0 from "./PatentFileForm.vue?vue&type=style&index=0&id=27bdc451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bdc451",
  null
  
)

export default component.exports